// import React, { useEffect, useState } from "react";
// import { Table, Spinner, Button, Input, Form, FormGroup, Label, Alert } from "reactstrap";
// import axiosInstance from "../../Request";
// import { URL } from "../../api";
// import moment from "moment";

// const PayoutReporting = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [exporting, setExporting] = useState(false);

//   // Filters
//   const [filterType, setFilterType] = useState("customerId");
//   const [filterValue, setFilterValue] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Pagination States
//   const [page, setPage] = useState(0);
//   const [size] = useState(30); // Matches backend default
//   const [hasNextPage, setHasNextPage] = useState(false);

//   const fetchPayouts = async (pageNo = 0) => {
//     setLoading(true);
//     try {
//       const filters = {};
//       if (filterValue.trim()) filters[filterType] = filterValue.trim();
//       if (fromDate) filters.fromDate = fromDate; 
//       if (toDate) filters.toDate = toDate;

//       const params = {
//         ...filters,
//         page: pageNo,
//         size: size,
//         // export parameter is omitted here for normal search
//       };

//       const response = await axiosInstance.get(URL.REPORTING_PAYOUTS, { params });
      
//       // The backend returns a direct List of Maps
//       const data = Array.isArray(response.data) ? response.data : [];
      
//       setRows(data);
//       setPage(pageNo);
//       setHasNextPage(data.length === size);
//     } catch (err) {
//       console.error("Error fetching payout data:", err);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayouts(0);
//   }, []);

//   const handleSearch = (e) => {
//     if (e) e.preventDefault();
//     fetchPayouts(0);
//   };

//   /** Scalable CSV Export utilizing Backend stream */
//   const handleExportCsv = async () => {
//     setExporting(true);
//     try {
//       const filters = {};
//       if (filterValue.trim()) filters[filterType] = filterValue.trim();
//       if (fromDate) filters.fromDate = fromDate;
//       if (toDate) filters.toDate = toDate;

//       const response = await axiosInstance.get(URL.REPORTING_PAYOUTS, {
//         params: { ...filters, export: true }, // export=true triggers CSV mode
//         responseType: "blob", 
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Payout_Report_${moment().format("YYYYMMDD")}.csv`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       alert("Export failed!");
//     } finally {
//       setExporting(false);
//     }
//   };

//   // Totals for current page
//   const totalAmount = rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
//   const totalFee = rows.reduce((sum, r) => sum + (Number(r.fee) || 0), 0);
//   const totalTax = rows.reduce((sum, r) => sum + (Number(r.tax) || 0), 0);

//   // Styling
//   const fontStyle = { fontSize: "10px" };
//   const inputSmStyle = { ...fontStyle, height: "30px", padding: "2px 6px" };
//   const buttonSmStyle = { ...fontStyle, padding: "4px 10px", height: "30px", lineHeight: "1" };
  
//   const currentLabel =
//     filterType === "customerId" ? "Customer ID" :
//     filterType === "loanId" ? "Loan ID" : "Amount";

//   return (
//     <div className="p-2" style={fontStyle}>
//       <Form onSubmit={handleSearch} className="mb-3">
//         <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">Filter Type</Label>
//             <Input type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputSmStyle}>
//               <option value="customerId">Customer ID</option>
//               <option value="loanId">Loan ID</option>
//               <option value="amount">Amount</option>
//             </Input>
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">{currentLabel}</Label>
//             <Input
//               type="text"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//               placeholder={`Enter ${currentLabel}`}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">From Date</Label>
//             <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
//           </FormGroup>

//           <FormGroup className="mb-0">
//             <Label className="mb-1 fw-bold">To Date</Label>
//             <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
//           </FormGroup>

//           <div className="d-flex" style={{ gap: "6px" }}>
//             <Button color="primary" type="submit" disabled={loading} style={buttonSmStyle}>
//               {loading ? <Spinner size="sm" /> : "Search"}
//             </Button>
//             <Button color="success" onClick={handleExportCsv} disabled={exporting || rows.length === 0} style={buttonSmStyle}>
//               {exporting ? <Spinner size="sm" /> : "Excel"}
//             </Button>
//           </div>
//         </div>
//       </Form>

//       {rows.length === 0 && !loading ? (
//         <Alert color="info">No records found.</Alert>
//       ) : (
//         <>
//           <div style={{ overflowX: "auto" }}>
//             <Table bordered striped hover responsive size="sm" className="mb-0 text-nowrap">
//               <thead className="table-light">
//                 <tr>
//                   <th>#</th>
//                   <th>ID</th>
//                   <th>DISBURSED ID</th>
//                   <th>CUST ID</th>
//                   <th>LOAN ID</th>
//                   <th>FUND ACC ID</th>
//                   <th>PAYOUT ID</th>
//                   <th>AMOUNT (₹)</th>
//                   <th>FEE (₹)</th>
//                   <th>TAX (₹)</th>
//                   <th>MODE</th>
//                   <th>PURPOSE</th>
//                   <th>STATUS</th>
//                   <th>UTR</th>
//                   <th>CREATE DATE</th>
//                   <th>UPDATE DATE</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((r, idx) => (
//                   <tr key={r.id}>
//                     <td>{page * size + idx + 1}</td>
//                     <td>{r.id}</td>
//                     <td>{r.disbursed_id}</td>
//                     <td>{r.customer_id}</td>
//                     <td>{r.loan_id}</td>
//                     <td>{r.fund_account_id}</td>
//                     <td>{r.payout_id}</td>
//                     <td className="fw-bold">{Number(r.amount || 0).toLocaleString('en-IN')}</td>
//                     <td>{Number(r.fee || 0).toLocaleString('en-IN')}</td>
//                     <td>{Number(r.tax || 0).toLocaleString('en-IN')}</td>
//                     <td>{r.mode}</td>
//                     <td>{r.purpose}</td>
//                     <td className={r.status === 'processed' ? 'text-success fw-bold' : ''}>{r.status}</td>
//                     <td>{r.utr || "-"}</td>
//                     <td>{r.create_date ? moment(r.create_date).format("DD-MM-YYYY HH:mm") : "-"}</td>
//                     <td>{r.update_date ? moment(r.update_date).format("DD-MM-YYYY HH:mm") : "-"}</td>
//                   </tr>
//                 ))}
//                 <tr className="table-secondary fw-bold">
//                   <td colSpan={7} className="text-end">Page Totals:</td>
//                   <td>₹{totalAmount.toLocaleString('en-IN')}</td>
//                   <td>₹{totalFee.toLocaleString('en-IN')}</td>
//                   <td>₹{totalTax.toLocaleString('en-IN')}</td>
//                   <td colSpan={6}></td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>

//           <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
//             <Button
//               color="outline-primary"
//               size="sm"
//               disabled={page === 0 || loading}  
//               onClick={() => fetchPayouts(page - 1)}
//               style={buttonSmStyle}
//             >
//               Previous
//             </Button>
//             <span className="fw-bold">Page {page + 1}</span>
//             <Button
//               color="outline-primary"
//               size="sm"
//               disabled={!hasNextPage || loading}
//               onClick={() => fetchPayouts(page + 1)}
//               style={buttonSmStyle}
//             >
//               Next
//             </Button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default PayoutReporting;

import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Input, Form, FormGroup, Label, Alert } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import moment from "moment";

const PayoutReporting = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);

  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // ✅ Fintech states
  const [fintechList, setFintechList] = useState([]);
  const [selectedFintechId, setSelectedFintechId] = useState("");

  const [page, setPage] = useState(0);
  const [size] = useState(30);
  const [hasNextPage, setHasNextPage] = useState(false);

  // ✅ Fintech list fetch - same as LoanReporting
  useEffect(() => {
    const fetchFintechs = async () => {
      try {
        const res = await axiosInstance.get(URL.LSP_LIST);
        setFintechList((res.data || []).filter((f) => f.isActive));
      } catch (err) {
        console.error("Failed to fetch fintech list:", err);
      }
    };
    fetchFintechs();
  }, []);

  const fetchPayouts = async (pageNo = 0) => {
    setLoading(true);
    try {
      const filters = {};
      if (filterValue.trim()) filters[filterType] = filterValue.trim();
      if (fromDate) filters.fromDate = fromDate;
      if (toDate) filters.toDate = toDate;
      if (selectedFintechId) filters.fintechId = selectedFintechId; // ✅

      const params = { ...filters, page: pageNo, size: size };

      const response = await axiosInstance.get(URL.REPORTING_PAYOUTS, { params });
      const data = Array.isArray(response.data) ? response.data : [];

      setRows(data);
      setPage(pageNo);
      setHasNextPage(data.length === size);
    } catch (err) {
      console.error("Error fetching payout data:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayouts(0);
  }, []);

  const handleSearch = (e) => {
    if (e) e.preventDefault();
    fetchPayouts(0);
  };

  const handleExportCsv = async () => {
    setExporting(true);
    try {
      const filters = {};
      if (filterValue.trim()) filters[filterType] = filterValue.trim();
      if (fromDate) filters.fromDate = fromDate;
      if (toDate) filters.toDate = toDate;
      if (selectedFintechId) filters.fintechId = selectedFintechId; // ✅

      const response = await axiosInstance.get(URL.REPORTING_PAYOUTS, {
        params: { ...filters, export: true },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Payout_Report_${moment().format("YYYYMMDD")}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Export failed!");
    } finally {
      setExporting(false);
    }
  };

  const totalAmount = rows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
  const totalFee = rows.reduce((sum, r) => sum + (Number(r.fee) || 0), 0);
  const totalTax = rows.reduce((sum, r) => sum + (Number(r.tax) || 0), 0);

  const fontStyle = { fontSize: "10px" };
  const inputSmStyle = { ...fontStyle, height: "30px", padding: "2px 6px" };
  const buttonSmStyle = { ...fontStyle, padding: "4px 10px", height: "30px", lineHeight: "1" };

  const currentLabel =
    filterType === "customerId" ? "Customer ID" :
    filterType === "loanId" ? "Loan ID" : "Amount";

  return (
    <div className="p-2" style={fontStyle}>
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Type</Label>
            <Input type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputSmStyle}>
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
              <option value="amount">Amount</option>
            </Input>
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">{currentLabel}</Label>
            <Input
              type="text"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              placeholder={`Enter ${currentLabel}`}
              style={inputSmStyle}
            />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">From Date</Label>
            <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">To Date</Label>
            <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>

          {/* ✅ Fintech Dropdown - same as LoanReporting */}
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Fintech</Label>
            <Input
              type="select"
              value={selectedFintechId}
              onChange={(e) => setSelectedFintechId(e.target.value)}
              style={{ ...inputSmStyle, width: 160 }}
            >
              <option value="">All Fintechs</option>
              {fintechList.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.brandName || f.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <div className="d-flex" style={{ gap: "6px" }}>
            <Button color="primary" type="submit" disabled={loading} style={buttonSmStyle}>
              {loading ? <Spinner size="sm" /> : "Search"}
            </Button>
            <Button color="success" onClick={handleExportCsv} disabled={exporting || rows.length === 0} style={buttonSmStyle}>
              {exporting ? <Spinner size="sm" /> : "Excel"}
            </Button>
          </div>
        </div>
      </Form>

      {/* Table same as before - no changes needed */}
      {rows.length === 0 && !loading ? (
        <Alert color="info">No records found.</Alert>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover responsive size="sm" className="mb-0 text-nowrap">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>DISBURSED ID</th>
                  <th>CUST ID</th>
                  <th>LOAN ID</th>
                  <th>FUND ACC ID</th>
                  <th>PAYOUT ID</th>
                  <th>AMOUNT (₹)</th>
                  <th>FEE (₹)</th>
                  <th>TAX (₹)</th>
                  <th>MODE</th>
                  <th>PURPOSE</th>
                  <th>STATUS</th>
                  <th>UTR</th>
                  <th>CREATE DATE</th>
                  <th>UPDATE DATE</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={r.id}>
                    <td>{page * size + idx + 1}</td>
                    <td>{r.id}</td>
                    <td>{r.disbursed_id}</td>
                    <td>{r.customer_id}</td>
                    <td>{r.loan_id}</td>
                    <td>{r.fund_account_id}</td>
                    <td>{r.payout_id}</td>
                    <td className="fw-bold">{Number(r.amount || 0).toLocaleString('en-IN')}</td>
                    <td>{Number(r.fee || 0).toLocaleString('en-IN')}</td>
                    <td>{Number(r.tax || 0).toLocaleString('en-IN')}</td>
                    <td>{r.mode}</td>
                    <td>{r.purpose}</td>
                    <td className={r.status === 'processed' ? 'text-success fw-bold' : ''}>{r.status}</td>
                    <td>{r.utr || "-"}</td>
                    <td>{r.create_date ? moment(r.create_date).format("DD-MM-YYYY HH:mm") : "-"}</td>
                    <td>{r.update_date ? moment(r.update_date).format("DD-MM-YYYY HH:mm") : "-"}</td>
                  </tr>
                ))}
                <tr className="table-secondary fw-bold">
                  <td colSpan={7} className="text-end">Page Totals:</td>
                  <td>₹{totalAmount.toLocaleString('en-IN')}</td>
                  <td>₹{totalFee.toLocaleString('en-IN')}</td>
                  <td>₹{totalTax.toLocaleString('en-IN')}</td>
                  <td colSpan={6}></td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
            <Button color="outline-primary" size="sm" disabled={page === 0 || loading} onClick={() => fetchPayouts(page - 1)} style={buttonSmStyle}>Previous</Button>
            <span className="fw-bold">Page {page + 1}</span>
            <Button color="outline-primary" size="sm" disabled={!hasNextPage || loading} onClick={() => fetchPayouts(page + 1)} style={buttonSmStyle}>Next</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PayoutReporting;